export async function fetchYtTitles(videoId, timeoutMs = 15000) {
	const cfg = (typeof window !== 'undefined' && window.__RESTREAMER_CONFIG__) || {};
	const titlesHost = cfg.YTDLP_TITLES_URL ? cfg.YTDLP_TITLES_URL.replace(/\/$/, '') : null;
	const primaryHost = cfg.YTDLP_URL ? cfg.YTDLP_URL.replace(/\/$/, '') : null;

	const tryFetchJson = async (url, ms) => {
		const controller = new AbortController();
		const timeoutId = setTimeout(() => controller.abort(), ms);
		try {
			const resp = await fetch(url, { signal: controller.signal });
			clearTimeout(timeoutId);
			if (!resp.ok) return { ok: false, status: resp.status };
			const data = await resp.json();
			return { ok: true, data };
		} catch (e) {
			clearTimeout(timeoutId);
			return { ok: false, error: e };
		}
	};

	// 1) Try titles host (/info then /stream)
	if (titlesHost) {
		// try /info
		const infoUrl = `${titlesHost}/info/${videoId}`;
		const infoResp = await tryFetchJson(infoUrl, timeoutMs);
		if (infoResp.ok) {
			const d = infoResp.data;
			return { title: d.title || d.video_title || '', description: d.description || d.video_description || '' };
		}

		// try /stream on the same host (some deployments expose metadata at /stream)
		const streamUrlHost = `${titlesHost}/stream/${videoId}`;
		const streamRespHost = await tryFetchJson(streamUrlHost, timeoutMs);
		if (streamRespHost.ok) {
			const d = streamRespHost.data;
			return { title: d.title || d.video_title || '', description: d.description || d.video_description || '' };
		}
	}

	// 2) Fallback to primary yt-dlp extractor (prefer /stream with longer timeout)
	if (primaryHost) {
		const streamUrl = `${primaryHost}/stream/${videoId}`;
		const streamResp = await tryFetchJson(streamUrl, 90000);
		if (streamResp.ok) {
			const d = streamResp.data;
			return { title: d.title || d.video_title || '', description: d.description || d.video_description || '' };
		}
		// optionally try /info on primary host
		const infoUrlPrim = `${primaryHost}/info/${videoId}`;
		const infoRespPrim = await tryFetchJson(infoUrlPrim, timeoutMs);
		if (infoRespPrim.ok) {
			const d = infoRespPrim.data;
			return { title: d.title || d.video_title || '', description: d.description || d.video_description || '' };
		}
	}

	throw new Error('No titles available');
}
